<template>
	<div>
		<foldSide v-bind="headerInfo" :logo="logo" v-on="$listeners">
			<!-- <chatActionItems v-bind="$attrs"  :nickname="headerInfo.nickname" isFold v-if="type==0"></chatActionItems>
		    <clue-action-items v-bind="$attrs" isFold v-if="type==1"></clue-action-items>
			<cust-action-items v-bind="$attrs"  isFold v-if="type==2"></cust-action-items> -->
		</foldSide>
	</div>
</template>

<script>
import foldSide from '@/components/chat/foldSide.vue';
import chatActionItems from '@/components/chat/fold/chat-action-items.vue';
import clueActionItems from '@/components/chat/fold/clue-action-items.vue';
import custActionItems from '@/components/chat/fold/cust-action-items.vue';
export default {
	props:{
		type:null,
		headerInfo:{
			type:Object,
		},
		logo:null
	},
	data() {
		return {};
	},
	components: { foldSide, chatActionItems,clueActionItems,custActionItems },
	computed: {},
	methods: {},
};
</script>
<style lang="scss" scoped></style>
